<template>
    <BreadcrumbVue />
    <section class="forms">
        <div class="container">
            <div class="informacoes">
                <div class="row">
                    <div class="col-lg-3" v-for="(info, index) in contato.informacoes" :key="'tel-' + index">
                        <div class="box-info">
                            <div class="icon">
                                <img :src="require('@/assets/imgs/phone-contato.png')" alt="">
                            </div>

                            <div class="titulo-info my-4">
                                <h5>Atendimento por Telefone</h5>
                            </div>

                            <div class="contato-info">
                                <span>{{ info.telefone_atendimento }}</span>
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-3" v-for="(info, index) in contato.informacoes" :key="'email-' + index">
                        <div class="box-info">
                            <div class="icon">
                                <img :src="require('@/assets/imgs/email-contato.png')" alt="">
                            </div>

                            <div class="titulo-info my-4">
                                <h5>Atendimento por E-mail</h5>
                            </div>

                            <div class="contato-info">
                                <span>{{ info.email_atendimento }}</span>
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-3" v-for="(info, index) in contato.informacoes" :key="'end-' + index">
                        <div class="box-info">
                            <div class="icon">
                                <img :src="require('@/assets/imgs/endereco-contato.png')" alt="">
                            </div>

                            <div class="titulo-info my-4">
                                <h5>Nosso Endereço</h5>
                            </div>

                            <div class="contato-info">
                                <span>{{ info.endereco }}</span>
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-3" v-for="(info, index) in contato.informacoes" :key="'hor-' + index">
                        <div class="box-info">
                            <div class="icon">
                                <img :src="require('@/assets/imgs/horario-contato.png')" alt="contato">
                            </div>

                            <div class="titulo-info my-4">
                                <h5>Horário de Atendimento</h5>
                            </div>

                            <div class="contato-info">
                                <span>{{ info.horario_funcionamento || info.horario }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="formularios">
                <div class="row">
                    <div class="col-lg-6">
                        <div class="titulo-contato" v-for="(form, index) in contato.formulario"
                            :key="'form-title-' + index">
                            <h2>{{ form.titulo_contato || form.titulo }}</h2>
                        </div>

                        <div class="filtro-forms">
                            <ul role="list">
                                <li role="listitem">
                                    <a href="javascript:;" @click="selectForm = 'contato'"
                                        :class="{ active: selectForm === 'contato' }">
                                        Envie-nos uma mensagem
                                    </a>
                                </li>
                                <li role="listitem">
                                    <a href="https://falabr.cgu.gov.br/web/servicos" target="_blank" rel="noopener noreferrer">
                                        Falar com a Ouvidoria
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>

                    <div class="col-lg-6" v-show="selectForm === 'contato'">
                        <div class="text-center">
                            <h3>Envie-nos uma mensagem</h3>
                        </div>

                        <form @submit.prevent="onSubmitContato">
                            <div class="row">
                                <div class="col-lg-12">
                                    <input type="text" class="form-control" placeholder="Nome"
                                        v-model.trim="contatoForm.nome">
                                </div>

                                <div class="col-lg-6">
                                    <input type="email" class="form-control" placeholder="E-mail"
                                        v-model.trim="contatoForm.email">
                                </div>

                                <div class="col-lg-6">
                                    <input type="text" class="form-control" placeholder="(xx) xxxxx-xxxxx"
                                        inputmode="numeric" autocomplete="tel" :value="contatoForm.telefone"
                                        @input="onPhoneInput($event, 'contato')">
                                </div>

                                <div class="col-lg-12">
                                    <input type="text" class="form-control" placeholder="Assunto"
                                        v-model.trim="contatoForm.assunto">
                                </div>

                                <div class="col-lg-12">
                                    <textarea class="form-control" rows="3" placeholder="Mensagem"
                                        v-model.trim="contatoForm.mensagem"></textarea>
                                </div>

                                <div class="col-lg-12">
                                    <div class="form-check">
                                        <input class="form-check-input" type="checkbox" id="termos-contato"
                                            v-model="contatoForm.termos">
                                        <label class="form-check-label" for="termos-contato">
                                            Li e aceito os termos de <a routerLink="/politica-de-privacidade">Política
                                                de privacidade</a>.
                                        </label>
                                    </div>
                                </div>

                                <div class="col-lg-4">
                                    <input type="submit" value="Enviar" :disabled="loadingContato">
                                </div>
                            </div>
                        </form>
                    </div>

                    <div class="col-lg-6" v-show="selectForm === 'ouvidoria'">
                        <div class="text-center">
                            <h3>Ouvidoria</h3>
                        </div>

                        <form @submit.prevent="onSubmitOuvidoria">
                            <div class="row">
                                <div class="col-lg-12">
                                    <input type="text" class="form-control" placeholder="Nome"
                                        v-model.trim="ouvidoriaForm.nome">
                                </div>

                                <div class="col-lg-6">
                                    <input type="email" class="form-control" placeholder="E-mail"
                                        v-model.trim="ouvidoriaForm.email">
                                </div>

                                <div class="col-lg-6">
                                    <input type="text" class="form-control" placeholder="(xx) xxxxx-xxxxx"
                                        inputmode="numeric" autocomplete="tel" :value="ouvidoriaForm.telefone"
                                        @input="onPhoneInput($event, 'ouvidoria')">
                                </div>

                                <div class="col-lg-12">
                                    <input type="text" class="form-control" placeholder="Assunto"
                                        v-model.trim="ouvidoriaForm.assunto">
                                </div>

                                <div class="col-lg-12">
                                    <textarea class="form-control" rows="3" placeholder="Mensagem"
                                        v-model.trim="ouvidoriaForm.mensagem"></textarea>
                                </div>

                                <div class="col-lg-12">
                                    <div class="form-check">
                                        <input class="form-check-input" type="checkbox" id="termos-ouvidoria"
                                            v-model="ouvidoriaForm.termos">
                                        <label class="form-check-label" for="termos-ouvidoria">
                                            Li e aceito os termos de <a routerLink="/politica-de-privacidade">Política
                                                de privacidade</a>.
                                        </label>
                                    </div>
                                </div>

                                <div class="col-lg-4">
                                    <input type="submit" value="Enviar" :disabled="loadingOuvidoria">
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>

        <svg xmlns="http://www.w3.org/2000/svg" width="1411" height="216" viewBox="0 0 1411 216" fill="none"
            preserveAspectRatio="none">
            <path
                d="M1414.09 0.387323L0.368164 0.387817L0.368169 15.578C459.524 276.15 918.681 287.835 1414.09 15.5775L1414.09 0.387323Z"
                fill="#F1F1F1" />
        </svg>
    </section>

    <section class="contato-page">
        <div class="container">
            <div class="row">
                <div class="col-lg-6">
                    <div class="titulo-contato">
                        <h2>Nossa Localização</h2>
                    </div>
                </div>

                <div class="col-lg-6">
                    <ul class="link-maps" role="list">
                        <li role="listitem" v-for="(loc, index) in contato.localizacao" :key="'maps-' + index">
                            <a :href="loc.link_maps" v-if="loc.link_maps != ''">
                                <img :src="require('@/assets/imgs/maps.png')" alt="Maps">
                                Abrir com o Google Maps
                            </a>
                        </li>

                        <li role="listitem" v-for="(loc, index) in contato.localizacao" :key="'waze-' + index">
                            <a :href="loc.link_waze" v-if="loc.link_waze != ''">
                                <img :src="require('@/assets/imgs/waze.png')" alt="Maps">
                                Abrir com o Waze
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>

        <div class="container-fluid mt-4">
            <div class="row" v-for="(map, index) in contato.localizacao" :key="'iframe-' + index">
                <span v-html="map.iframe_maps || map.iframe_map"></span>
            </div>
        </div>
    </section>

    <Popup />
    <FooterInternas />
</template>

<script>
import axios from "axios";

import FooterInternas from "../components/FooterInternas/FooterInternas.vue";
import BreadcrumbVue from "../components/Breadcrumb/Breadcrumb.vue";
import Popup from "@/components/Popup/PopupComponent.vue";

const CONTATOURL = "https://api.cref20.org.br/wp-json/cref/v1/contato";
const SEND_EMAIL_URL = "https://api.cref20.org.br/wp-json/cref/v1/enviarEmail";

export default {
    name: "ContatoPage",
    components: { FooterInternas, BreadcrumbVue, Popup },

    data() {
        return {
            contato: {
                informacoes: [],
                formulario: [],
                localizacao: [],
            },

            selectForm: "contato",

            contatoForm: {
                nome: "",
                email: "",
                telefone: "",
                assunto: "",
                mensagem: "",
                termos: false,
            },

            ouvidoriaForm: {
                nome: "",
                email: "",
                telefone: "",
                assunto: "",
                mensagem: "",
                termos: false,
            },

            loadingContato: false,
            loadingOuvidoria: false,
        };
    },

    async mounted() {
        const { data } = await axios.get(CONTATOURL);
        const payload = Array.isArray(data) ? data[0] : data;

        this.contato = {
            informacoes: payload?.corpo?.informacoes || [],
            formulario: payload?.corpo?.formulario || [],
            localizacao: payload?.corpo?.localizacao || [],
        };
    },

    methods: {
        formatPhoneBRShort(raw) {
            const digits = String(raw || "").replace(/\D/g, "").slice(0, 10);
            if (!digits) return "";

            const ddd = digits.slice(0, 2);
            const part1 = digits.slice(2, 6);
            const part2 = digits.slice(6, 10);

            if (digits.length <= 2) return `(${ddd}`;
            if (digits.length <= 6) return `(${ddd}) ${part1}`;
            return `(${ddd}) ${part1}-${part2}`;
        },


        onPhoneInput(e, type) {
            const formatted = this.formatPhoneBRShort(e.target.value);
            e.target.value = formatted;

            if (type === "contato") this.contatoForm.telefone = formatted;
            if (type === "ouvidoria") this.ouvidoriaForm.telefone = formatted;
        },

        async sendForm(payload) {
            const res = await axios.post(SEND_EMAIL_URL, payload, {
                headers: { "Content-Type": "application/json" },
            });
            return res.data;
        },

        async onSubmitContato() {
            if (!this.contatoForm.termos) {
                alert("Você precisa aceitar a política de privacidade.");
                return;
            }

            this.loadingContato = true;

            try {
                await this.sendForm({
                    nome: this.contatoForm.nome,
                    email: this.contatoForm.email,
                    telefone: this.contatoForm.telefone,
                    assunto: this.contatoForm.assunto,
                    mensagem: this.contatoForm.mensagem,
                });

                alert("Mensagem enviada com sucesso!");

                this.contatoForm = {
                    nome: "",
                    email: "",
                    telefone: "",
                    assunto: "",
                    mensagem: "",
                    termos: false,
                };
            } catch (err) {
                console.error(err);
                alert("Falha ao enviar. Veja o console/network.");
            } finally {
                this.loadingContato = false;
            }
        },

        async onSubmitOuvidoria() {
            if (!this.ouvidoriaForm.termos) {
                alert("Você precisa aceitar a política de privacidade.");
                return;
            }

            this.loadingOuvidoria = true;

            try {
                await this.sendForm({
                    nome: this.ouvidoriaForm.nome,
                    email: this.ouvidoriaForm.email,
                    telefone: this.ouvidoriaForm.telefone,
                    assunto: this.ouvidoriaForm.assunto,
                    mensagem: this.ouvidoriaForm.mensagem,
                });

                alert("Mensagem enviada com sucesso!");

                this.ouvidoriaForm = {
                    nome: "",
                    email: "",
                    telefone: "",
                    assunto: "",
                    mensagem: "",
                    termos: false,
                };
            } catch (err) {
                console.error(err);
                alert("Falha ao enviar. Veja o console/network.");
            } finally {
                this.loadingOuvidoria = false;
            }
        },
    },
};
</script>

<style scoped>
.forms {
    background-color: #f1f1f1;
}

.forms .informacoes .box-info {
    border-radius: 15px;
    box-shadow: 0px 4px 14px 0px rgba(0, 0, 0, 0.15);
    padding: 60px 18px;
    text-align: center;
    background-color: #fff;
    height: 295px;
}

.forms .informacoes .box-info .titulo-info h5 {
    color: #5f5e5e;
    text-align: center;
    font-size: 18px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    text-transform: uppercase;
}

.forms .informacoes .box-info .contato-info span {
    color: #6c6e71;
    text-align: center;
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
}

.forms .formularios {
    margin-top: 3.5rem;
}

.forms .formularios .titulo-contato h2 {
    color: #393939;
    font-size: 40px;
    font-style: normal;
    font-weight: 500;
}

.forms .formularios .filtro-forms ul {
    list-style: none;
    padding: 0;
}

.forms .formularios .filtro-forms ul li {
    margin: 20px 0;
}

.forms .formularios .filtro-forms ul li a {
    text-decoration: none;
    border: 1px solid #45A047;
    padding: 10px;
    width: 267px;
    display: block;
    text-align: center;
    border-radius: 50px;
    color: #403e3e;
    font-size: 20px;
    font-style: normal;
    font-weight: 400;
}

.forms .formularios .filtro-forms ul li a.active {
    background-color: #45A047;
    color: #fff;
}

.forms .formularios .filtro-forms ul li a:hover {
    background-color: #45A047;
    color: #fff;
    transition: 0.3s;
}

.forms .formularios form .form-control {
    height: 5vh;
    margin: 5px 0;
}

.forms .formularios form textarea {
    height: 15vh !important;
}

.forms .formularios form .form-check label {
    color: #575757;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 110%;
}

.forms .formularios form input[type="submit"] {
    margin-top: 10px;
    background-color: #45A047;
    border: none;
    padding: 10px 20px;
    color: #fff;
    font-size: 20px;
    font-style: normal;
    font-weight: 700;
    text-transform: uppercase;
    border-radius: 50px;
}

section.forms {
    position: relative;
    top: -207px;
}

.breadcrumb-topo {
    position: relative;
    z-index: 10;
}

.informacoes .row {
    position: relative;
    z-index: 11;
    margin-top: 50px;
}

.titulo-contato h2 {
    color: #393939;
    font-size: 40px;
    font-style: normal;
    font-weight: 500;
}

.contato-page {
    margin-top: 4rem;
}

.contato-page .link-maps {
    display: flex;
    list-style: none;
    align-items: center;
}

.contato-page .link-maps li {
    margin: 0 10px;
}

.contato-page .link-maps li a {
    border-radius: 10px;
    border: 1px solid #cdcdcd;
    background: #fff;
    box-shadow: 0px 4px 14px 0px rgba(0, 0, 0, 0.15);
    padding: 20px;
    color: #5e5e5e;
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    text-decoration: none;
}

svg {
    width: 100%;
    position: relative;
    top: 208px;
}

@media (max-width: 1390px) {
    .contato-page .link-maps li a {
        font-size: 15px;
    }
}

@media (max-width: 765px) {
    svg {
        display: none;
    }
}
</style>
